// The full set of grief-mod flag keys. Used by client + both backends.
export const MOD_KEYS = [
  "giantSprite",
  "tinyPipes",
  "reverseGravity",
  "invisibleObstacles",
  "rainbowLizard",
  "invertedControls",
  "discoPipes",
  "longNeck",
  "zeroGravity",
  "slipperyAir",
  "earrapeFlap",
  "speedUp",
  "slowMotion",
  "glitchedTextures",
  "upsideDownScreen",
  "blindMode",
  "fakeBanScreen",
  "spamFlapSound",
  "brokenHitbox",
  "flapBackward",
  "shakeyCamera",
  "jumpscare",
];

export const MOD_LABELS = {
  giantSprite: "Giant Sprite",
  tinyPipes: "Tiny Pipes",
  reverseGravity: "Reverse Gravity",
  invisibleObstacles: "Invisible Obstacles",
  rainbowLizard: "Rainbow Lizard",
  invertedControls: "Inverted Controls",
  discoPipes: "Disco Pipes",
  longNeck: "Long Neck",
  zeroGravity: "Zero Gravity",
  slipperyAir: "Slippery Air",
  earrapeFlap: "Earrape Flap",
  speedUp: "Speed Up",
  slowMotion: "Slow Motion",
  glitchedTextures: "Glitched Textures",
  upsideDownScreen: "Upside-down Screen",
  blindMode: "Blind Mode",
  fakeBanScreen: "Fake Ban Screen",
  spamFlapSound: "Spam Flap Sound",
  brokenHitbox: "Broken Hitbox",
  flapBackward: "Flap Backward",
  shakeyCamera: "Shakey Camera",
  jumpscare: "Jumpscare",
};

export function emptyMods() {
  const out = {};
  for (const k of MOD_KEYS) out[k] = false;
  return out;
}

export function sanitizeMods(raw) {
  if (!raw || typeof raw !== "object") return null;
  const out = {};
  for (const k of MOD_KEYS) out[k] = Boolean(raw[k]);
  return out;
}

export function anyEnabled(mods) {
  if (!mods) return false;
  for (const k of MOD_KEYS) if (mods[k]) return true;
  return false;
}

// Legacy mods are the original admin-only toggles (noclip + injected starting
// score/flies). Unlike grief flags they include integers, so they ride in their
// own slice of the pushable payload.
function clampInt(v) {
  const n = Math.floor(Number(v));
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.min(999999, n);
}

export function emptyLegacy() {
  return { noclip: false, startingScore: 0, startingFlies: 0 };
}

export function sanitizeLegacy(raw) {
  if (!raw || typeof raw !== "object") return emptyLegacy();
  return {
    noclip: Boolean(raw.noclip),
    startingScore: clampInt(raw.startingScore),
    startingFlies: clampInt(raw.startingFlies),
  };
}

export function anyLegacy(legacy) {
  if (!legacy) return false;
  return Boolean(legacy.noclip) || clampInt(legacy.startingScore) > 0 || clampInt(legacy.startingFlies) > 0;
}

// The full pushable payload: boolean grief flags + the legacy slice. Accepts the
// old flat-ModFlags shape too, so rows written before this change still parse.
export function sanitizeModPayload(raw) {
  if (!raw || typeof raw !== "object") return null;
  if ("flags" in raw || "legacy" in raw) {
    return {
      flags: sanitizeMods(raw.flags) ?? emptyMods(),
      legacy: sanitizeLegacy(raw.legacy),
    };
  }
  const flags = sanitizeMods(raw);
  if (!flags) return null;
  return { flags, legacy: emptyLegacy() };
}
